import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'
import {
    IconButton,
    Tooltip
} from '@material-ui/core'
import BookmarkIcon from '@material-ui/icons/Bookmark'

import { ToggleButton } from '../Atoms'
import { UserService } from "../../services"
import { Analytics } from "../../utils"

const checkBookmarked = (clauseId, bookmarks) => {
    if (!bookmarks) return false
    return bookmarks.includes(clauseId)
}

const useBookmarkState = (type) => {
    const [bookmarks, setBookmarks] = React.useState([])
    const updateBookmarks = id => () => {
        if (bookmarks.includes(id)) {
            setBookmarks(bookmarks.filter(bookmark => bookmark !== id))
            if (type === "clause") {
                return UserService.updateClauseBookmark(id, false)
            } else if (type === "deed") {
                return UserService.updateDeedBookmark(id, false)
            }
        } else {
            setBookmarks([...bookmarks, id])
            if (type === "clause") {
                return UserService.updateClauseBookmark(id, true)
            } else if (type === "deed") {
                return UserService.updateDeedBookmark(id, true)
            }
        }
    }

    React.useEffect(() => {
        let isSubscribed = true
        UserService.getUser()
            .then(json => {
                if (isSubscribed) {
                    if (type === "clause") {
                        setBookmarks(json.bookmarked_clauses || [])
                    } else if (type === "deed") {
                        setBookmarks(json.bookmarked_deeds || [])
                    }
                }
            })
        return () => isSubscribed = false
    }, [type])

    return [bookmarks, updateBookmarks]
}

const useStyles = makeStyles(theme => ({
    isNotBookmarked: {
        justifyContent: 'center',
        marginLeft: 10,
        marginRight: 10,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        }
    },
    isBookmarked: {
        justifyContent: 'center',
        marginLeft: 10,
        marginRight: 10,
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        }
    },
}))

const BookmarkButton = ({ isBookmarked, updateBookmarks, variant = "large", style = {} }) => {
    const { t } = useTranslation()
    const classes = useStyles()

    const handleClick = (event) => {
        event.stopPropagation()
        Analytics.buttonClickEvent("Bookmark Button")
        updateBookmarks()
    }

    if (variant === "large") {
        return <ToggleButton
            style={style}
            onClick={handleClick}
            on={isBookmarked}
            onText={t('bookmark.bookmarked')}
            offText={t('bookmark.notBookmarked')}
            startIcon={<BookmarkIcon />}
        />
    } else if (variant === "small") {
        return <Tooltip
            title={isBookmarked ? t('bookmark.bookmarked') : t('bookmark.notBookmarked')}
            aria-label={isBookmarked ? t('bookmark.bookmarked') : t('bookmark.notBookmarked')}>
            <IconButton
                style={style}
                variant="outlined"
                className={isBookmarked ? classes.isBookmarked : classes.isNotBookmarked}
                onClick={handleClick}
            >
                <BookmarkIcon />
            </IconButton >
        </Tooltip>
    }
}

export default BookmarkButton
export { useBookmarkState, checkBookmarked }